import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import "./Switch.css";

function SwitchComponent({isOn,handleToggle,className}) {
  const id = uuidv4();
  return (
    <div className={`d-flex justify-content-center align-items-center ${className}`}>
      <p className="mb-0" style={{marginRight:10,color:'#606060',fontSize:'.9rem'}}>Acumulado</p>
      <input
        checked={isOn}
        onChange={handleToggle}
        className="react-switch-checkbox"
        id={`switch-grafica-${id}`}
        type="checkbox"
      />
      <label
        style={{ background: isOn && '#0ca1b4' }}
        className="react-switch-label"
        htmlFor={`switch-grafica-${id}`}
      >
        <span className={`react-switch-button`} />
      </label>
      <p className="mb-0" style={{marginLeft:10,color:'#0ca1b4',fontWeight:'600',fontSize:'.9rem'}}>Por Periodo</p>
    </div>
  );
};

function SwitchComponentProd({isOn,handleToggle,className}) {
  const id = uuidv4();
  return (
    <div className={`d-flex justify-content-center align-items-center ${className}`}>
      <p className="mb-0" style={{marginRight:10,color:'#606060',fontSize:'.9rem'}}>Producción</p>
      <input
        checked={isOn}
        onChange={handleToggle}
        className="react-switch-checkbox"
        id={`switch-grafica-${id}`}
        type="checkbox"
      />
      <label
        style={{ background: isOn && '#0ca1b4' }}
        className="react-switch-label"
        htmlFor={`switch-grafica-${id}`}
      >
        <span className={`react-switch-button`} />
      </label>
      <p className="mb-0" style={{marginLeft:10,color:'#0ca1b4',fontWeight:'600',fontSize:'.9rem'}}>Cobranza</p>
    </div>
  );
};

function SwitchComponentPolizas({isOn,handleToggle,className}) {
  const id = uuidv4();
  return (
    <div className={`d-flex justify-content-center align-items-center ${className}`}>
      <p className="mb-0" style={{marginRight:10,color:'#606060',fontSize:'.9rem'}}>Nuevas</p>
      <input
        checked={isOn}
        onChange={handleToggle}
        className="react-switch-checkbox"
        id={`switch-grafica-${id}`}
        type="checkbox"
      />
      <label
        style={{ background: isOn && '#0ca1b4' }}
        className="react-switch-label"
        htmlFor={`switch-grafica-${id}`}
      >
        <span className={`react-switch-button`} />
      </label>
      <p className="mb-0" style={{marginLeft:10,color:'#0ca1b4',fontWeight:'600',fontSize:'.9rem'}}>Renovadas</p>
    </div>
  );
};

function SwitchComponentFiles({isOn,handleToggle,className}) {
  const id = uuidv4();
  return (
    <div className={`d-flex justify-content-center align-items-center ${className}`}>
      <p className="mb-0" style={{marginRight:10,color:'#606060',fontSize:'.9rem'}}>Datos</p>
      <input
        checked={isOn}
        onChange={handleToggle}
        className="react-switch-checkbox"
        id={`switch-grafica-${id}`}
        type="checkbox"
      />
      <label
        style={{ background: isOn && '#0ca1b4' }}
        className="react-switch-label"
        htmlFor={`switch-grafica-${id}`}
      >
        <span className={`react-switch-button`} />
      </label>
      <p className="mb-0" style={{marginLeft:10,color:'#0ca1b4',fontWeight:'600',fontSize:'.9rem'}}>Archivos</p>
    </div>
  );
};

function SwitchOnOff({isOn,handleToggle,className}){
  const id = uuidv4();
  return (
    <div className={`d-flex ${className} align-items-center justify-content-center`}>
      {/* <p className="mb-0" style={{marginRight:10,color:'#606060',fontSize:'.9rem'}}>Deshabilitado</p> */}
      <input
        checked={isOn}
        onChange={handleToggle}
        className="react-switch-checkbox"
        id={`switch-grafica-${id}`}
        type="checkbox"
      />
      <label
        style={{ background: isOn && '#0ca1b4' }}
        className="react-switch-label"
        htmlFor={`switch-grafica-${id}`}
      >
        <span className={`react-switch-button`} />
      </label>
      {/* <p className="mb-0" style={{marginLeft:10,color:'#0ca1b4',fontWeight:'600',fontSize:'.9rem'}}>Habilitado</p> */}
    </div>
  );
}

function SwitchOnOffLeft({isOn,handleToggle,className}){
  const id = uuidv4();
  return (
    <div className={`d-inline-flex align-items-center justify-content-start`}>
      <p className="mb-0" style={{marginRight:10,color:'#606060',fontSize:'.9rem'}}>Deshabilitado</p>
      <input
        checked={isOn}
        onChange={handleToggle}
        className="react-switch-checkbox"
        id={`switch-grafica-${id}`}
        type="checkbox"
      />
      <label
        style={{ background: isOn && '#0ca1b4' }}
        className="react-switch-label"
        htmlFor={`switch-grafica-${id}`}
      >
        <span className={`react-switch-button`} />
      </label>
      <p className="mb-0" style={{marginLeft:10,color:'#0ca1b4',fontWeight:'600',fontSize:'.9rem'}}>Habilitado</p>
    </div>
  );
}

export {
  SwitchComponent,
  SwitchComponentProd,
  SwitchOnOff,
  SwitchOnOffLeft,
  SwitchComponentFiles,
  SwitchComponentPolizas
}
